import { PMTaskDefinition } from '@dynamika-shared/types/pmTaskDefinitions';

export type TaskDefinitionSortState = string | undefined;

const compareStrings = (
  left: string,
  right: string,
  direction: 'asc' | 'desc'
) =>
  left.localeCompare(right, undefined, {
    numeric: true,
    sensitivity: 'base',
  }) * (direction === 'asc' ? 1 : -1);

export const sortTaskDefinitions = (
  rows: PMTaskDefinition[],
  sortState?: TaskDefinitionSortState
) => {
  if (!sortState) {
    return [...rows];
  }

  const [field, direction = 'asc'] = sortState.split(',') as [
    keyof PMTaskDefinition,
    'asc' | 'desc',
  ];

  return [...rows].sort((left, right) => {
    if (field === 'taskDefinitionOrder') {
      const diff =
        (left.taskDefinitionOrder ?? 0) - (right.taskDefinitionOrder ?? 0);
      return direction === 'asc' ? diff : -diff;
    }

    if (field !== 'code' && field !== 'name') {
      return 0;
    }

    const leftValue = left[field] ?? '';
    const rightValue = right[field] ?? '';
    return compareStrings(leftValue, rightValue, direction);
  });
};
